export default function DisplaySection ({ color, label, value, unit, graphic }) {
  let backgroundColor;
  let borderColor;
  let valueColor;
  let unitColor;

  // Determine colors based on the label
  if (color === 'blue') {
    backgroundColor = '#eff6ff'; // bg-blue-50
    borderColor = '#bfdbfe'; // border-blue-200
    valueColor = '#1d4ed8'; // text-blue-700
    unitColor = '#2563eb'; // text-blue-600
  } else if (color === 'green') {
    backgroundColor = '#ecfdf5'; // bg-green-50
    borderColor = '#a7f3d0'; // border-green-200
    valueColor = '#047857'; // text-green-700
    unitColor = '#374151'; // text-gray-700
  } else if (color === 'red') {
    backgroundColor = '#fef2f2'; // bg-red-50
    borderColor = '#fecaca'; // border-red-200
    valueColor = '#b91c1c'; // text-red-700
    unitColor = '#dc2626'; // text-red-600
  } else if (color === 'gray') {
    backgroundColor = '#f9fafb'; // bg-gray-50
    borderColor = '#e5e7eb'; // border-gray-200
    valueColor = '#374151'; // text-gray-700
    unitColor = '#6b7280'; // text-gray-600
  } else if (color === 'purple') {
    backgroundColor = '#faf5ff'; // bg-purple-50
    borderColor = '#e9d5ff'; // border-purple-200
    valueColor = '#6b21a8'; // text-purple-700
    unitColor = '#7e22ce'; // text-purple-600
  } else if (color === 'orange') {
    backgroundColor = '#fff7ed'; // bg-orange-50
    borderColor = '#fed7aa'; // border-orange-200
    valueColor = '#c2410c'; // text-orange-700
    unitColor = '#ea580c'; // text-orange-600
  } else if (color === 'yellow') {
    backgroundColor = '#fefce8'; // bg-yellow-50
    borderColor = '#fde68a'; // border-yellow-200
    valueColor = '#b45309'; // text-yellow-700
    unitColor = '#ca8a04'; // text-yellow-600
  } else {
    // Default to gray for any unknown color
    backgroundColor = '#f9fafb';
    borderColor = '#e5e7eb';
    valueColor = '#374151';
    unitColor = '#6b7280';
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: backgroundColor,
        padding: '0.75rem',
        borderRadius: '0.375rem',
        border: `1px solid ${borderColor}`,
      }}
    >
      <span
        style={{
          color: '#4b5563', // text-gray-600
          fontWeight: '500',
          fontSize: '1rem',
        }}
      >
        {label}
      </span>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
        }}
      >
        <span
          style={{
            color: valueColor,
            fontSize: '1.25rem',
            fontWeight: '600',
          }}
        >
          {value}
        </span>
        {unit && (
          <span
            style={{
              fontSize: '0.875rem',
              fontWeight: '400',
              color: unitColor,
            }}
          >
            {unit}
          </span>
        )}
        {graphic}
      </div>
    </div>
  );
};